/** Matches ``CHECKOUT_QUERY_TRIAL_UPGRADED`` on the Django checkout redirect. */
export const CHECKOUT_QUERY_TRIAL_UPGRADED = 'trial_upgraded';

export const TRIAL_UPGRADED_NOTICE_MESSAGE =
  'Membership upgraded. Remaining sessions are being generated and may take a few minutes to appear.';

export function isTrialUpgradedCheckout(searchParams: URLSearchParams): boolean {
  return searchParams.get('checkout') === CHECKOUT_QUERY_TRIAL_UPGRADED;
}

export function clearTrialUpgradedCheckoutQuery(searchParams: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(searchParams);
  next.delete('checkout');
  return next;
}
